import { Box } from 'theme-ui'
import matter from 'gray-matter'

import List from '../../components/pages/blog/List'
import Meta from '../../components/Meta'
import Header from '../../components/Header'

const Index = (props) => {
    return (
        <section>
            <Box sx={{ minHeight: '100vh', pb: 10 }}>
                <Meta
                    title="Blog | TinyFaces NFT"
                    description="Welcome to the TinyFaces NFT blog where we tell our story, priorities, plans, and pivots to bring our project to live."
                />
                <Header />
                <Box sx={{ maxWidth: 1230, margin: 'auto' }}>
                    <Box
                        as="h1"
                        sx={{
                            fontFamily: 'heading',
                            fontSize: 9,
                            lineHeight: 1.1,
                            textAlign: 'center',
                            mb: 7,
                            mt: 8,
                        }}
                    >
                        Blog
                    </Box>
                    <List allBlogs={props.allBlogs} />
                </Box>
            </Box>
        </section>
    )
}

export default Index

export async function getStaticProps() {
    const webpackContext = require.context('../../posts', true, /\.md$/)
    // the list of file names contained
    // inside the "posts" directory
    const keys = webpackContext.keys()
    const values = keys.map(webpackContext)

    // getting the post data from the files contained
    // in the "posts" folder
    const posts = keys.map((key, index) => {
        // dynamically creating the post slug
        // from file name
        const slug = key
            .replace(/^.*[\\\/]/, '')
            .split('.')
            .slice(0, -1)
            .join('.')

        // getting the .md file value associated
        // with the current file name
        const value = values[index]

        // parsing the YAML metadata and markdown body
        // contained in the .md file
        const document = matter(value.default)

        return {
            frontmatter: document.data,
            markdownBody: document.content,
            slug,
        }
    })

    return {
        props: {
            allBlogs: posts,
        },
    }
}
